import RecurringErrorMessage from 'components/RecurringErrorMessage/styled';

export default RecurringErrorMessage;
